import ErrorComponent from 'Components/ErrorComponent'
import PopUp from 'Components/PopUp'
import TableLoading from 'Components/TableLoading'
import ToolTip from 'Components/ToolTip'
import { dateTimeFormat, formattooltip, searchPorts } from 'GenericForms/Helper'
import Layout from 'HorizontalMenu/Menu'
import Navbar from 'HorizontalMenu/Navbar'
import React, { useState } from 'react'
import { useQuery } from 'react-query'
import AsyncSelect from 'react-select/async'
import { Button, Card, CardBody, Col, Container, Label, Row } from 'reactstrap'
import { customStyle } from 'shared/CommonCSS'
import { queryKeyes } from 'shared/queryKeys'
import { Get } from 'VesselMaster/vesselMaster.hooks'

const OtherPort = () => {
    const [hoverId, setHoverId] = useState<string>("")
    const [AddPortBoolean, setAddPortBoolean] = useState<boolean>(false)
    const [ReplacePortBoolean, setReplacePortBoolean] = useState<boolean>(false)
    const [portId, setPortId] = useState<number>(0)
    const [replacePortID, setReplacePortID] = useState<string>("")
    /** Fetch Other Ports from master */
    const { data: portData1, isLoading: OtherPortsLoading, isError: OtherPortsError }:
        { data: any, isLoading: any, isError?: any } = useQuery(
            [queryKeyes.masters.OtherPortMaster.key],
            async () => await Get(queryKeyes.masters.OtherPortMaster.url()),
            { staleTime: Infinity }
        )

    const portData = portData1 ?? []
    const handleReplacePort = () => {
        // Logic to replace the port using portId
        // You can add your API call or state update logic here
        console.warn(`Replacing port ${portId} with ${replacePortID}`)
        setReplacePortBoolean(false)
    }
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <h2 className="mb-0">Other Port</h2>
                        </Col>
                    </Row>
                    {OtherPortsLoading && <TableLoading />}
                    {OtherPortsError && <ErrorComponent message='Unable to load required data!' />}
                    {!(OtherPortsLoading) && !(OtherPortsError) && (
                        <div className="table-responsive">
                            <table className="table mt-4 align-middle">
                                <thead className="table-light">
                                    <tr>
                                        <th className="p-2 text-center">#</th>
                                        <th className="p-2">Port Name</th>
                                        <th className="p-2">Country Name</th>
                                        <th className="p-2">Vessel</th>
                                        <th className="p-2">Report (Local Date & Time)</th>
                                        <th className="p-2 text-center">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {portData.length > 0 ? (
                                        portData.map((port: any, index: number) => (
                                            <tr key={port.id}>
                                                <td className="p-2 text-center">{index + 1}</td>
                                                <td className="p-2">{port.port_name}</td>
                                                <td className="p-2">{port.country_name}</td>
                                                <td className="p-2">{port.vessel_name}</td>
                                                <td className="p-2">
                                                    {port.event_name}{' '}
                                                    {port.local_time && (
                                                        <span className="text-muted">
                                                            ({dateTimeFormat(port.local_time, false, false, true)})
                                                        </span>
                                                    )}
                                                </td>
                                                <td className="p-2 text-center">
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-primary waves-effect waves-light me-1"
                                                        id={`Add_Port_${port.id}`}
                                                        onMouseEnter={() => setHoverId(`Add_Port_${port.id}`)}
                                                        onMouseLeave={() => setHoverId("")}
                                                        onClick={() => {
                                                            setHoverId(null)
                                                            setPortId(port.id)
                                                            setAddPortBoolean(true)
                                                        }}
                                                    >
                                                        <i className="bx bx-edit-alt font-size-16 align-middle"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        className="btn btn-soft-primary waves-effect waves-light"
                                                        id={`Replace_Port_${port.id}`}
                                                        onMouseEnter={() => setHoverId(`Replace_Port_${port.id}`)}
                                                        onMouseLeave={() => setHoverId("")}
                                                        onClick={() => {
                                                            setHoverId(null)
                                                            setPortId(port.id)
                                                            setReplacePortBoolean(true)
                                                        }}
                                                    >
                                                        <i className="bx bx-repost font-size-16 align-middle"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan={6} className="text-center p-3">
                                                No Other Ports Available
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    )}
                    {hoverId && document.getElementById(hoverId) !== null && (
                        <ToolTip
                            target={hoverId}
                            message={formattooltip(hoverId)}
                            isOpen={!!hoverId}
                        />
                    )}
                    {AddPortBoolean && (
                        <PopUp
                            title="Add Other Port"
                            state={AddPortBoolean}
                            setState={setAddPortBoolean}
                            size="sm"
                            body={
                                <Card className="shadow-sm border-0">
                                    <div className="text-center">
                                        <h6 className="mb-4">Are you sure you want to add this port?</h6>
                                        <div className="d-flex justify-content-end gap-3">
                                            <Button
                                                color="primary"
                                                className='mr-1'
                                                onClick={() => setAddPortBoolean(false)}
                                            >
                                                Confirm
                                            </Button>
                                        </div>
                                    </div>
                                </Card>
                            }
                        />
                    )}
                    {ReplacePortBoolean && (
                        <PopUp
                            title="Replace Other Port"
                            state={ReplacePortBoolean}
                            setState={setReplacePortBoolean}
                            size="md"
                            body={
                                <Card className="shadow-sm border-0">
                                    <CardBody>
                                        <div className="text-center mb-3">
                                            <h6 className="fw-semibold mb-4">
                                                Are you sure you want to replace this port?
                                            </h6>
                                        </div>
                                        <div className='p-1 '>
                                            <Row>
                                                <Col lg={6}>
                                                    <Label className='asteric mb-0'>Select Port</Label>
                                                    <AsyncSelect
                                                        name="port"
                                                        inputId="port"
                                                        cacheOptions
                                                        defaultOptions
                                                        loadOptions={(e: any) => searchPorts(e)}
                                                        getOptionLabel={(e: any) => e.port_country_name}
                                                        getOptionValue={(e) => e.id}
                                                        className="select-height mb-4"
                                                        menuPortalTarget={document.body}
                                                        styles={customStyle}
                                                        onChange={(e: any) => {
                                                            setReplacePortID(e.id)
                                                        }}
                                                        noOptionsMessage={(e: any) => {
                                                            if (e?.inputValue?.toString()?.length > 2) {
                                                                return "Please select the Other option and enter the port name in the textbox provided"
                                                            }
                                                            return "Please enter the first 3 characters of port name"
                                                        }}
                                                    />
                                                </Col>
                                            </Row>
                                            <div className="d-flex justify-content-end gap-2">
                                                <Button
                                                    color="primary"
                                                    onClick={() => { handleReplacePort() }}
                                                >
                                                    Confirm
                                                </Button>
                                            </div>
                                        </div>
                                    </CardBody>
                                </Card>
                            }
                        />
                    )}
                </Container>
            </div>
        </React.Fragment>
    )
}

export default OtherPort
